import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    FlartCopyStatus: 'idle',
    FlartCopyError: undefined as any,

    flartCopyList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const FlartCopy = createAsyncThunk('flartCopySlice/FlartCopy', async ({ flartCopy }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/FlartMenu_Copy/`,
        prepareData(flartCopy),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { FlartCopyStatus } = getState().flartCopySlice
        return FlartCopyStatus !== 'pending'
    }
})

const FlartCopySlice = createSlice({
    name: 'flartCopySlice',
    initialState,
    reducers: {
        resetFlartCopyError: (state) => {
            state.FlartCopyError = undefined
        },
        removeFromFlartCopyListById: (state, action) => {
            state.flartCopyList = state.flartCopyList.filter((x: any) => x.None !== action.payload)
        },
        removeFromFlartCopyListByIds: (state, action) => {
            state.flartCopyList = state.flartCopyList.filter((x: any) => action.payload.indexOf(x.None) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flartCopyList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.FlartCopyStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flartCopyList = []
            state.FlartCopyStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(FlartCopy.pending, (state) => {
            state.FlartCopyStatus = 'pending'
            state.FlartCopyError = undefined
        })
        builder.addCase(FlartCopy.fulfilled, (state, action) => {
            state.FlartCopyStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flartCopyList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flartCopyList.push(newItem) }
                else { state.flartCopyList[i] = { ...state.flartCopyList[i], ...newItem } }
            }
        })
        builder.addCase(FlartCopy.rejected, (state, action) => {
            state.FlartCopyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.FlartCopyError = action.error.message
            } else {
                state.FlartCopyError = action.payload
            }
        })

    }
})

export const {
    resetFlartCopyError,
    removeFromFlartCopyListById,
    removeFromFlartCopyListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlartCopySlice.actions
export default FlartCopySlice.reducer
